import {Directive, ElementRef, HostListener, Input} from '@angular/core';
import KeyDownEvent = JQuery.KeyDownEvent;

@Directive({
    selector: '[minimumEnforce]'
})
export class MinimumEnforceDirective {

    // Properties
    @Input() allowDecimal = false;
    @Input() minimumEnforce: number;
    @Input() maximumEnforce: number;

    private allowedKeys: Array<string> = [ 
        'Backspace', 
        'End', 
        'Home',
        'ArrowRight',
        'ArrowLeft',
        'Tab',
        'Delete'
    ];
    private disallowedKeys: Array<string> = [' '];
    private numberOfCharacters

    constructor(private el: ElementRef) {}

    @HostListener('keydown', [ '$event' ])
    onKeyDown(event: KeyDownEvent) {
        if (this.minimumEnforce) {
            const minimumEnforceString = this.minimumEnforce.toString();
            const maximumEnforceString = this.maximumEnforce.toString();
    
            // If the number of characters is not supplied, assume it is equal to the minimum enforce
            if (!this.maximumEnforce) {
                this.numberOfCharacters = minimumEnforceString.length;
            } else {
                if (maximumEnforceString.includes('.')) {
                    this.numberOfCharacters = maximumEnforceString.slice(0, maximumEnforceString.indexOf('.')).length;
                } else {
                    this.numberOfCharacters = maximumEnforceString.length;
                }
            }
    
            // If the number of characters is greater than the minimum enforced value,
            if (this.numberOfCharacters > minimumEnforceString.length) {
                return;
            }
    
            // Allow some characters without doing anything
            if (this.allowedKeys.includes(event.key)) {
                return;
            }
    
            // Don't allow certain characters at all
            if (this.disallowedKeys.includes(event.key)) {
                event.preventDefault();
            }
    
            // Obtaining the new value
            let current: string = this.el.nativeElement.value;
            const indexStart = event.target.selectionStart;
            const indexEnd = event.target.selectionEnd;
            const key = event.key;
            let next: string = current.slice(0, indexStart) + key + current.slice(indexEnd + Math.abs(0));
            let nextNumber: number = Number(next);

            // If we just have a hyphen, that's allowed because of negatives
            if (next == '-') {
                return;
            }

            // If we have just a decimal and we allove decimals, let that be
            if (next == '.' && this.allowDecimal) {
                return;
            }
    
            // If we're allowing a decimal, we need to truncate it to the number of positions we have
            next = nextNumber.toString();   // This is weird, but it trims all leading 0s
            let checkValue = this.minimumEnforce;
            let checkValueString = checkValue.toString();
            const checkDecimalIndex = checkValue.toString().indexOf('.');
            if (this.allowDecimal && checkDecimalIndex >= 0) {
                const nextDecimalIndex = next.indexOf('.');
                if (nextDecimalIndex >= 0) {
                    const nextPrecision = next.length - nextDecimalIndex - 1;
                    if (nextPrecision > 0) {
                        checkValueString = checkValueString.slice(0, checkDecimalIndex) + checkValueString.slice(checkDecimalIndex, checkDecimalIndex + nextPrecision + 1);
                        checkValue = Number.parseFloat(checkValueString);
                    } else {
                        checkValue = Math.floor(checkValue);
                    }
                } else {
                    checkValue = Math.floor(checkValue);
                }
            }
    
            // If the next value has less length than the minimum enforce, we need to pad with the minimum value
            // NOTE: we can only do this with positive numbers. Negative numbers can't support lookahead.
            if (!next.includes('.') && this.minimumEnforce > 0 && next.length < minimumEnforceString.length) {
                let newValueString = next;
                for (let i = next.length; i < minimumEnforceString.length; i++) {
                    newValueString += minimumEnforceString[i];
                }
                nextNumber = Number.parseFloat(newValueString);
            }
    
            // Checking the new value
            if (
                (this.allowDecimal || !next.includes('.'))
                && !isNaN(nextNumber)
                && nextNumber >= checkValue
            ) {
                return;
            }
    
            // Preventing if we haven't allowed it yet
            event.preventDefault();
            return;
        }
    }
}
